import {
  motion,
  PanInfo,
  useMotionValue,
  useSpring,
  useTransform,
} from "framer-motion";
import { useEffect, useRef } from "react";
import { useWindowSize } from "react-use";
import styled from "styled-components";
import { videoWallConfig } from "../../mock/video-wall";
import { fill } from "../../styles/utils";

interface VideoWallBoardMobileProps {
  onStopAnimating?: (v: boolean) => any;
}

const MotionContainer = styled(motion.div)`
  ${fill()}
  background-color: red;
  touch-action: none;
`;

const MotionBoard = styled(motion.div)`
  position: absolute;
  height: ${videoWallConfig.heightFactor * 100}vh;
  width: ${videoWallConfig.widthFactor * 100}vw;
  left: ${((videoWallConfig.widthFactor - 1) * -100) / 2}vw;
  top: ${((videoWallConfig.heightFactor - 1) * -100) / 2}vh;
  background-color: ${({ theme }) => theme.colors.blueDark};
`;

export const VideoWallBoardMobile: React.FC<VideoWallBoardMobileProps> = ({
  children,
  onStopAnimating,
}) => {
  const xStop = useRef(0);
  const yStop = useRef(0);
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const { width, height } = useWindowSize();

  const calcMove = (v: number, limit: number): number => {
    if (v > 0) {
      return v < limit ? v : limit;
    }
    return v > -limit ? v : -limit;
  };

  const handlePan = (
    _: MouseEvent | TouchEvent | PointerEvent,
    info: PanInfo
  ) => {
    const xDrag = info.offset.x + xStop.current;
    const yDrag = info.offset.y + yStop.current;
    const xMove = calcMove(xDrag, width / 2);
    const yMove = calcMove(yDrag, height / 2);
    console.log(x);
    x.set(xMove);
    y.set(yMove);
  };

  const handlePanEnd = (
    e: MouseEvent | TouchEvent | PointerEvent,
    info: PanInfo
  ) => {
    const xDrag = info.offset.x + xStop.current;
    const yDrag = info.offset.y + yStop.current;
    const xMove = calcMove(xDrag, width / 2);
    const yMove = calcMove(yDrag, height / 2);

    xStop.current = xMove;
    yStop.current = yMove;
  };

  useEffect(() => {
    const unSub = x.onChange((v) => {
      if (onStopAnimating) {
        const v = x.getVelocity();
        console.log(v);
        if (v < 0.8 && v > -0.8) {
          onStopAnimating(true);
        } else {
          onStopAnimating(false);
        }
      }
    });

    return () => {
      unSub();
    };
  }, [x, onStopAnimating]);

  const physics = { stiffness: 80, mass: 1, damping: 20 };
  const xMov = useSpring(x, physics);
  const yMov = useSpring(y, physics);

  return (
    <MotionContainer onPan={handlePan} onPanEnd={handlePanEnd}>
      <MotionBoard style={{ x: xMov, y: yMov }}>{children}</MotionBoard>
    </MotionContainer>
  );
};
